import React from 'react';
import { Form, Icon } from 'semantic-ui-react';
import Cleave from 'cleave.js/react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Required from '../Required';
import ErrorMessage from '../ErrorMessage';

const DateLabel = () => (
  <Icon
    name="calendar"
    style={{
      position: 'absolute',
      margin: 0,
      left: 1,
      borderTop: 0,
      borderBottom: 0,
      borderLeft: 0,
      marginTop: 1,
      height: 36,
      paddingTop: 8,
      width: 'auto',
      paddingLeft: 12,
      textAlign: 'center',
      background: 'transparent',
      border: '0px solid',
    }}
  />
);

export class DatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cleave: {},
    };
  }

  componentWillReceiveProps = (nextProps) => {
    const { value } = nextProps;
    if (this.props.value !== value && value) {
      this.state.cleave.setRawValue(value.format('DD/MM/YYYY')); // eslint-disable-line
    }
    if (!value && this.state.cleave.setRawValue) {
      this.state.cleave.setRawValue('');
    }
  };

  onValueInit = (cleave) => {
    this.setState({ cleave });
    const { value } = this.props;
    cleave.setRawValue(value ? value.format('DD/MM/YYYY') : '');
  };

  cleave = null;

  render() {
    const {
      onChange,
      touched,
      setFieldTouched,
      errors,
      name,
      label,
      disabled,
      /* type, */ required,
      style,
      blurCallback,
      onClick,
    } = this.props;
    return (
      <Form.Field error={Boolean(touched[name] && errors[name])} style={style} className="relative">
        <label htmlFor={name}>
          {label}
          <Required required={required} />
        </label>
        <Cleave
          name={name}
          disabled={disabled}
          placeholder="GG/MM/AAAA"
          onInit={this.onValueInit}
          onClick={onClick}
          options={{
            date: true,
            datePattern: ['d', 'm', 'Y'],
          }}
          onBlur={(e) => {
            if (setFieldTouched) {
              setFieldTouched(name, true);
            }
            if (e.target.value) {
              onChange(name, moment(e.target.value, 'DD/MM/YYYY'));
            }
            if (!e.target.value) {
              onChange(name, '');
            }
            if (blurCallback && typeof blurCallback === 'function') blurCallback(e);
          }}
          style={{ paddingLeft: 32, paddingRight: 2 }}
        />
        <DateLabel />
        {touched[name] && errors[name] && <ErrorMessage>{errors[name]}</ErrorMessage>}
      </Form.Field>
    );
  }
}

export default DatePicker;

DatePicker.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  touched: PropTypes.object,
  errors: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  // type: PropTypes.string,
  required: PropTypes.bool,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  blurCallback: PropTypes.func,
  setFieldTouched: PropTypes.func,
  onClick: PropTypes.func,
  // onBlur: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/components/Forms/UI/DatePicker/index.js